"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineActivityPackage = defineActivityPackage;
/**
 * 定义活动包模块的类型检查辅助函数
 *
 * 此函数在编译时确保活动包模块符合 ActivityModule 接口规范，
 * 但在运行时不会执行任何操作（会被编译器优化掉）。
 *
 * @example
 * ```typescript
 * import { defineActivityPackage } from '@ark/activity-core';
 * import { MyConfiguration } from './module';
 * import { activityConfig } from './config';
 *
 * // 标准 Midway 组件导出
 * export { MyConfiguration as Configuration };
 * export { activityConfig };
 *
 * // 编译时类型检查
 * defineActivityPackage({
 *   Configuration: MyConfiguration,
 *   activityConfig,
 * });
 * ```
 *
 * @param module - 活动包模块对象
 * @returns 原样返回传入的模块对象
 */
function defineActivityPackage(module) {
    return module;
}
